import type { AppUser } from "@/lib/authApi";

/**
 * Role constants - use this instead of string literals to prevent bugs
 */
export const Role = {
  ADMIN: "Admin",
  SENIOR: "Senior",
  COMPTABLE: "Comptable",
  BOUTIQUE: "Boutique",
  FLEURISTE: "Fleuriste",
  PREPARATEUR: "Preparateur",
  ATELIER: "Atelier",
  LIVREUR: "Livreur",
} as const;

export type Role = (typeof Role)[keyof typeof Role];

/**
 * User-facing role names. The values in `Role` are the API contract and stay
 * unaccented; never render them directly.
 */
const ROLE_LABELS: Record<string, string> = {
  Admin: "Admin",
  Senior: "Senior",
  Comptable: "Comptable",
  Boutique: "Boutique",
  Fleuriste: "Fleuriste",
  Preparateur: "Préparateur",
  Atelier: "Atelier",
  Livreur: "Livreur",
};

/** Display name for a role, falling back to the raw value. */
export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role;
}

export type { AppUser };

export interface AuthState {
  user: AppUser | null;
  loading: boolean;
  phone: string | null;
  displayName: string | null;
  role: Role | null;
  location: string | null;
}

export interface AuthContextType extends AuthState {
  signInWithPhone: (phone: string) => Promise<void>;
  verifyOtp: (phone: string, token: string) => Promise<void>;
  signOut: () => Promise<void>;
  resetAuth: () => void;
  getAccessToken: () => Promise<string | null>;
  error: string | null;
  otpSent: boolean;
  hasRole: (role: Role) => boolean;
}
